const prefixoAdmin = "/admin";
const privilegioAdmin = [9];
import auth from "../middleware/auth";

export default [
    {
        path: `${prefixoAdmin}/home`,
        name: "home-admin",
        component: () => import("@/pages/admin/home/Inicio.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/obras`,
        name: "Crud-Obras-admin",
        component: () => import("@/pages/conteudo/crud/obra/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/disciplinas`,
        name: "Crud-Disciplinas-admin",
        component: () => import("../pages/conteudo/crud/disciplina/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/escolas`,
        name: "Crud-Escolas-admin",
        component: () => import("../pages/conteudo/crud/escola/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/contratos`,
        name: "crud-contrato-page-admin",
        component: () => import("@/pages/conteudo/crud/contrato/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/turmas`,
        name: "crud-turmas-page-admin",
        component: () => import("@/pages/conteudo/crud/turmas/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/usuarios`,
        name: "crud-usuario-page-admin",
        component: () => import("@/pages/conteudo/crud/usuario/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/pnld`,
        name: "Crud-Usuarios-admin",
        component: () =>
            import("@/pages/conteudo/crud/pnldCompartilhamento/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/relatorio-questoes`,
        name: "relatorio-questoes-admin",
        component: () => import("@/pages/conteudo/relatorioQuestoes/Inicio.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/mais-saber/relatorio-questoes`,
        name: "relatorio-questoes-mais-saber-admin",
        component: () =>
            import("@/pages/conteudo/relatorioQuestoesMaisSaber/Inicio.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/conteudos`,
        name: "conteudos-admin",
        component: () => import("../pages/conteudo/crud/conteudos/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/atividade/adicionar-editar-questao/:id_questao?`,
        name: "adicionar-editar-questoes-atividade-admin",
        component: () =>
            import(
                "../pages/conteudo/relatorioQuestoes/AdicionarEditarQuestaoAtividade.vue"
            ),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/avaliacao/adicionar-editar-questao/:id_questao?`,
        name: "adicionar-editar-questoes-avaliacao-admin",
        component: () =>
            import(
                "../pages/conteudo/relatorioQuestoes/AdicionarEditarQuestaoAvaliacao.vue"
            ),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/mais-saber/avaliacao/adicionar-editar-questao/:id_questao?`,
        name: "adicionar-editar-questoes-avaliacao-mais-saber",
        component: () =>
            import(
                "../pages/conteudo/relatorioQuestoesMaisSaber/AdicionarEditarQuestaoAvaliacao.vue"
            ),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    //cruds reds
    {
        path: `${prefixoAdmin}/crud/saeb`,
        name: "Crud-Saeb-admin",
        component: () => import("../pages/conteudo/crud/saeb/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/bncc`,
        name: "Crud-BNCC-admin",
        component: () => import("../pages/conteudo/crud/bncc/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/objeto-conhecimento`,
        name: "Crud-Objeto-Conhecimento-admin",
        component: () =>
            import("../pages/conteudo/crud/objetoConhecimento/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/habilidade`,
        name: "Crud-Conteudo-Aberto-admin",
        component: () => import("../pages/conteudo/crud/habilidade/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/banner-home`,
        name: "Crud-BannerHome-admin",
        component: () => import("../pages/conteudo/crud/bannerHome/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/podcast`,
        name: "Crud-Podcast-admin",
        component: () => import("../pages/conteudo/crud/podcast/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/audios-ingles`,
        name: "Crud-Audio-ingles-admin",
        component: () => import("../pages/conteudo/crud/audioIngles/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/sequencia-didatica`,
        name: "Crud-Sequencia-didatica-admin",
        component: () =>
            import("../pages/conteudo/crud/sequenciaDidatica/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "sequencia",
        },
    },
    {
        path: `${prefixoAdmin}/crud/planejamentos`,
        name: "Crud-Planejamentos-admin",
        component: () =>
            import("../pages/conteudo/crud/sequenciaDidatica/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "planejamento",
        },
    },
    {
        path: `${prefixoAdmin}/crud/infograficos-mapas`,
        name: "Crud-Infograficos-admin",
        component: () =>
            import("../pages/conteudo/crud/infograficosMapas/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/videos`,
        name: "Crud-Videos-admin",
        component: () => import("../pages/conteudo/crud/videos/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },

    {
        path: `${prefixoAdmin}/crud/videoaulas-animacoes`,
        name: "Crud-Videoaulas-admin",
        component: () =>
            import("../pages/conteudo/crud/videoaulasAnimacoes/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/projetos-integradores`,
        name: "Crud-Projetos-Integradores-admin",
        component: () =>
            import("../pages/conteudo/crud/sequenciaDidatica/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "projeto_integrador",
        },
    },

    {
        path: `${prefixoAdmin}/crud/audios-ingles`,
        name: "Crud-Audios-Ingles-admin",
        component: () => import("../pages/conteudo/crud/podcast/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "audio_ingles",
        },
    },
    {
        path: `${prefixoAdmin}/crud/livros`,
        name: "Crud-Livros-admin",
        component: () => import("../pages/conteudo/crud/livro/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/conteudo-aberto`,
        name: "Conteudo-Aberto-admin",
        component: () => import("../pages/conteudo/conteudoAberto/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/conteudo-aberto/adicionar-editar-conteudo`,
        name: "Adicionar-Editar-conteudo-admin",
        component: () =>
            import("../pages/conteudo/conteudoAberto/AdicionarEditarArtigo.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },

    //cruds assessoria
    {
        path: `${prefixoAdmin}/crud/encontros-pedagogicos`,
        name: "Crud-Encontros-Pedagogicos-admin",
        component: () =>
            import("../pages/conteudo/crud/encontrosPedagogicos/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "encontro",
        },
    },
    {
        path: `${prefixoAdmin}/crud/informacoes`,
        name: "Crud-Informacoes-admin",
        component: () => import("../pages/conteudo/crud/informacoes/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
        props: {
            tipo: "informacao",
        },
    },
    {
        path: `${prefixoAdmin}/crud/conteudo-apoio`,
        name: "Crud-Conteudo-Apoio-admin",
        component: () => import("../pages/conteudo/crud/conteudoApoio/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/crud/marketing-educacional`,
        name: "Crud-Marketing-Educacional-admin",
        component: () =>
            import("../pages/conteudo/crud/marketingEducacional/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },

    {
        path: `${prefixoAdmin}/relatorios/questao-habilidade`,
        name: "Relatorio-Questao-Habilidade-admin",
        component: () =>
            import("../pages/conteudo/relatorios/questaoHabilidade/HomeView.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/relatorios/questao-habilidade/atividade`,
        name: "Relatorio-Questao-Habilidade-Atividade-admin",
        component: () =>
            import(
                "../pages/conteudo/relatorios/questaoHabilidade/atividade/HomeView.vue"
            ),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
    {
        path: `${prefixoAdmin}/relatorios/questao-habilidade/avaliacao`,
        name: "Relatorio-Questao-Habilidade-Avaliacao-admin",
        component: () =>
            import(
                "../pages/conteudo/relatorios/questaoHabilidade/avaliacao/HomeView.vue"
            ),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioAdmin,
        },
    },
]